import { PropsWithChildren } from "react";

export function ErrorChip({children}: PropsWithChildren<{}>) {
  return <span className="text-red-500 mt-0.5">{children}</span>
}

export function ErrorWrapper({ children, error }: PropsWithChildren<{ error?: string; }>) {
    return <span className="w-full flex flex-col">
        {children}
        {error && <ErrorChip>{error}</ErrorChip>}
    </span>;
}

